import { render, staticRenderFns } from "./TermsFooterComponent.vue?vue&type=template&id=5800c9f6"
import script from "./TermsFooterComponent.vue?vue&type=script&lang=js"
export * from "./TermsFooterComponent.vue?vue&type=script&lang=js"
import style0 from "./TermsFooterComponent.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports